import VueRouter from "vue-router";

//push
const VueRouterPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch((err) => err);
};

//replace
const VueRouterReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function replace(to) {
  return VueRouterReplace.call(this, to).catch((err) => err);
};
const mobileRouter = [
  {
    path: "/",
    name: "mobile",
    component: () => import("@/views/mobile/index.vue"),
    redirect: "/mobile/home",
    meta: {
      title: "中思拓研究院",
      desc: "促进决策科学化，为社会创造新价值",
    },
    children: [
      {
        path: "/mobile/home",
        name: "home",
        component: () => import("@/views/mobile/home/index.vue"),
        meta: {
          title: "中思拓研究院",
          desc: "促进决策科学化，为社会创造新价值",
        },
      },
      {
        path: "/mobile/solution",
        name: "solution",
        component: () => import("@/views/mobile/solution/solution.vue"),
        meta: {
          desc: "解决方案",
        },
      },
      {
        path: "/mobile/solution1",
        name: "solution1",
        component: () => import("@/views/mobile/solution/solution1.vue"),
        meta: {
          desc: "房屋智能估价解决方案",
        },
      },
      {
        path: "/mobile/solution2",
        name: "solution2",
        component: () => import("@/views/mobile/solution/solution2.vue"),
        meta: {
          desc: "数据服务解决方案",
        },
      },
      {
        path: "/mobile/solution3",
        name: "solution3",
        component: () => import("@/views/mobile/solution/solution3.vue"),
        meta: {
          desc: "住房市场监测及预警的解决方案",
        },
      },
      {
        path: "/mobile/solution4",
        name: "solution4",
        component: () => import("@/views/mobile/solution/solution4.vue"),
        meta: {
          desc: "地址数据治理的解决方案",
        },
      },
      {
        path: "/mobile/collateral",
        name: "collateral",
        component: () =>
          import("@/views/mobile/dataServe/components/Collateral.vue"),
        meta: {
          desc: "房屋智能估价",
        },
      },
      {
        path: "/mobile/dataInsight",
        name: "dataInsight",
        component: () =>
          import("@/views/mobile/dataServe/components/DataInsight.vue"),
        meta: {
          desc: "数据服务",
        },
      },

      {
        path: "/mobile/customization",
        name: "customization",
        component: () =>
          import("@/views/mobile/dataServe/components/Customization.vue"),
        meta: {
          desc: "定制服务",
        },
      },
      {
        path: "/mobile/warnReport",
        name: "warnReport",
        component: () =>
          import("@/views/mobile/researchlist/warnReport.vue"),
        meta: {
          desc: "预警报告",
        },
      },
      {
        path: "/mobile/dataReport",
        name: "dataReport",
        component: () =>
          import("@/views/mobile/researchlist/dataReport.vue"),
                meta: {
          desc: "研究报告",
        },
      },

      {
        path: "/mobile/researchlist",
        name: "researchlist",
        redirect: "/mobile/researchlist/warnReport",
        component: () => import("@/views/mobile/researchlist/index.vue"),
        children: [
          {
            path: "/mobile/researchlist/warnReport",
            name: "warnReport",
            component: () =>
              import("@/views/mobile/researchlist/warnReport.vue"),
          },
          {
            path: "/mobile/researchlist/dataReport",
            name: "dataReport",
            component: () =>
              import("@/views/mobile/researchlist/dataReport.vue"),
          },
          {
            path: "/mobile/researchlist/subjectReport",
            name: "subjectReport",
            component: () =>
              import("@/views/mobile/researchlist/subjectReport.vue"),
          },
        ],
      },
      {
        path: "/mobile/newslist",
        name: "newslist",
        redirect: "/mobile/newslist/newslist",
        component: () => import("@/views/mobile/newslist/index.vue"),
        meta: {},
        children: [
          {
            path: "/mobile/newslist/newslist",
            name: "newslist",
            component: () =>
              import("@/views/mobile/newslist/newslist.vue"),
          },
          {
            path: "/mobile/newslist/hotnewlist",
            name: "hotnewlist",
            component: () =>
              import("@/views/mobile/newslist/hotNewList.vue"),
          },

        ],
      },
      // {
      //   path: "/mobile/newslist",
      //   name: "newslist",
      //   component: () => import("@/views/mobile/newslist/newslist.vue"),
      //   meta: {},
      // },
      {
        path: "/mobile/details",
        name: "details",
        component: () => import("@/views/mobile/details/details.vue"),
        meta: {},
      },
      {
        path: "/mobile/about",
        name: "about",
        component: () => import("@/views/mobile/about/Index.vue"),
        meta: {
          desc: "",
        },
      },

      {
        path: "/mobile/dataServe",
        name: "dataServe",
        redirect: "/mobile/dataServe/collateral",
        component: () => import("@/views/mobile/dataServe/Index.vue"),
        children: [
          {
            path: "/mobile/dataServe/dataInsight",
            name: "dataInsight",
            component: () =>
              import("@/views/mobile/dataServe/components/DataInsight.vue"),
            meta: {},
          },
          {
            path: "/mobile/dataServe/collateral",
            name: "collateral",
            component: () =>
              import("@/views/mobile/dataServe/components/Collateral.vue"),
            meta: {},
          },
          {
            path: "/mobile/dataServe/customization",
            name: "customization",
            component: () =>
              import("@/views/mobile/dataServe/components/Customization.vue"),
            meta: {},
          },
        ],
      },
      {
        path: "/mobile/bigNewList",
        name: "bigNewList",
        component: () => import("@/views/mobile/bigNewList/Index.vue"),
      },
      {
        path: "/mobile/videoList",
        name: "videoList",
        component: () => import("@/views/mobile/videoList/videoList.vue"),
      },
      {
        path: "/mobile/videoDetail",
        name: "videoDetail",
        component: () => import("@/views/mobile/videoList/videoDetail.vue"),
      },
    ],
  },
  {
    path: "/mobile/dataView",
    name: "dataView",
    component: () => import("@/views/mobile/dataView/index.vue"),
    meta: {
      desc: "",
    },
  },



  {
    path: "*",
    redirect: "/",
  },
  {
    path: "/mobile/specialTopic",
    component: () => import("@/views/mobile/specialTopic/specialTopic.vue"),
    meta: {
      title: "2023中国房地产企业健康评价报告会在京举行",
      desc: "",
    },
  },
  {
    path: "/mobile/specialTopic3",
    component: () => import("@/views/mobile/specialTopic/specialTopic3.vue"),
    meta: {
      title: "专题3",
      desc: "",
    },
  },
  {
    path: "/mobile/specialTopic2",
    component: () => import("@/views/mobile/specialTopic/specialTopic2.vue"),
    meta: {
      title: "专题2",
      desc: "",
    },
  },
  {
    path: "/mobile/specialTopic1",
    component: () => import("@/views/mobile/specialTopic/specialTopic1.vue"),
    meta: {
      title: "专题1",
      desc: "",
    },
  },
];

export default mobileRouter;
